import user from '@/stores/user';
import storage from '@/utils/storage';
import { ethers } from 'ethers';
import { useEffect } from 'react';

export const FIRST_VISIT_KEY = 'has_performed_first_cleanup_20251223';
const AUTH_TOKEN_KEY = 'auth-token';

export default function useFirstVisitCleanup() {
    useEffect(() => {
        const hasPerformedCleanup = localStorage.getItem(FIRST_VISIT_KEY);

        if (!hasPerformedCleanup) {
            // 1. Clear login info
            user.clearLoginInfo();

            // 2. Clear auth token
            storage.remove(AUTH_TOKEN_KEY);

            // 3. Disconnect wallet
            const disconnectWallet = async () => {
                try {
                    if ((window as any).ethereum) {
                        const provider = new ethers.BrowserProvider(
                            (window as any).ethereum,
                        );
                        await provider.send('wallet_revokePermissions', [
                            { eth_accounts: {} },
                        ]);
                    }
                } catch (e) {
                    console.error('Failed to revoke permissions', e);
                }
            };
            disconnectWallet();

            // 4. Mark as done
            localStorage.setItem(FIRST_VISIT_KEY, 'true');

            console.log('First visit cleanup performed');
        }
    }, []);
}
